var _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPdf(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 35,
    viewBox: "0 0 38 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.9311 22.4902H13.085V25.9971H13.9311C14.3467 25.9971 14.6807 25.8672 14.9256 25.6074C15.1705 25.3477 15.2967 25.0127 15.2967 24.6094V23.8779C15.2967 23.4746 15.1705 23.1465 14.9256 22.8867C14.6807 22.6201 14.3467 22.4902 13.9311 22.4902Z",
    fill: "#F15F5F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.1346 19.5439H2.99121V28.6973H23.4978L27.1346 19.5439ZM10.6803 24.418C10.3537 24.6914 9.90839 24.8213 9.33691 24.8213H8.21621V26.6328H7.34785V21.8477H9.33691C9.90839 21.8477 10.3611 21.9844 10.6803 22.2578C11.0068 22.5313 11.1701 22.8867 11.1701 23.3311C11.1701 23.7891 11.0068 24.1445 10.6803 24.418ZM16.1576 24.6094C16.1576 25.2109 15.9498 25.6963 15.5416 26.0723C15.126 26.4482 14.5916 26.6396 13.931 26.6396H12.2166V21.8545H13.931C14.5916 21.8545 15.126 22.0459 15.5416 22.4219C15.9572 22.7979 16.1576 23.29 16.1576 23.8848V24.6094ZM20.6553 22.4902H18.1986V23.9531H20.2916V24.5957H18.1986V26.6396H17.3303V21.8545H20.6553V22.4902Z",
    fill: "#F15F5F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.33701 22.4902H8.21631V24.1787H9.33701C9.65615 24.1787 9.90108 24.0967 10.0644 23.9395C10.2276 23.7822 10.3093 23.584 10.3093 23.3379C10.3093 23.0918 10.2276 22.8936 10.0644 22.7295C9.90108 22.5723 9.65615 22.4902 9.33701 22.4902Z",
    fill: "#F15F5F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M26.1922 0.410156H7.97148C7.42969 0.410156 6.98438 0.820312 6.98438 1.31934V18.874H8.95859V2.22852H26.1922V8.53125H33.0352V32.7715H8.95859V29.3672H6.98438V33.6807C6.98438 34.1797 7.42969 34.5898 7.97148 34.5898H34.0223C34.5641 34.5898 35.0094 34.1797 35.0094 33.6807V8.53125L26.1922 0.410156Z",
    fill: "#F15F5F"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M30.4003 11.7168H11.5933V13.0566H30.4003V11.7168Z",
    fill: "#F15F5F"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M27.4241 14.3213H11.5933V15.6611H27.4241V14.3213Z",
    fill: "#F15F5F"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdf);
export default __webpack_public_path__ + "static/media/Pdf.49576fa7.svg";
export { ForwardRef as ReactComponent };